import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from 'src/app/shared/base-service/base-service.service';
import { Chamado } from '../interfaces/chamado';
import { ValoresChamado } from '../interfaces/valores-chamado';
import { Tarefa } from '../interfaces/tarefa';
import { TipoAtendimento } from '../interfaces/tipo-atendimento';
import { Pendencia } from '../../pendencias/interfaces/pendencia';
import { InfoCobrancaChamado } from 'src/app/shared/interfaces/info-cobranca-chamado';
import { ChamadosAbertosFilter } from '../interfaces/chamados-abertos-filter';

@Injectable({
  providedIn: 'root'
})
export class ChamadosService extends BaseService<Chamado> {

  constructor(protected http: HttpClient) {
    super(http, 'chamados');
  }

  getAbertos(queryParams: ChamadosAbertosFilter | null = null) {
    let params = new HttpParams();

    if (queryParams) {
      Object.entries(queryParams).forEach(([chave, valor]: [string, string | string]) => {
        if (chave !== 'agendado') {
          Object.entries(queryParams[chave]).forEach(([chave2, valor2]: [string, string[]]) => {
            if (queryParams[chave]['value'] !== null && (typeof queryParams[chave]['value'] === 'object' && !!queryParams[chave]['value'].length))
              params = params.set(chave + '[' + chave2 + ']', typeof valor2 !== 'object' ? valor2 : valor2.join('|'));
          });
        }
        else if (valor !== null)
          params = params.set(chave, valor);
      });
    }

    return this.http.get<Chamado[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/abertos`, { params: params });
  }

  getAgendados(filtro: any[] = []) {
    let params = new HttpParams();

    Object.keys(filtro).forEach(item => params = params.append(item, filtro[item]));

    return this.http.get<Chamado[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/agendados`, { params: params });
  }

  getFinalizados() {
    return this.http.get<Chamado[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/finalizados`);
  }

  getByCliente(clienteId: number) {
    return this.http.get<Chamado[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/clientes/${clienteId}`);
  }

  getValores(endClienteId: number, tipoChamadoId: number, equipamentoId: number) {
    let params = new HttpParams();

    params = params.append('end_cliente_id', endClienteId.toString());
    params = params.append('tipo_chamado_id', tipoChamadoId.toString());

    if (equipamentoId)
      params = params.append('equipamento_id', equipamentoId.toString());

    return this.http.get<ValoresChamado>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/valores`, { params: params });
  }

  getDescricaoCobranca(endClienteId: number, tipoChamadoId: number, equipamentoId: number) {
    let params = new HttpParams();

    params = params.append('end_cliente_id', endClienteId.toString());
    params = params.append('tipo_chamado_id', tipoChamadoId.toString());
    params = params.append('equipamento_id', equipamentoId.toString());

    return this.http.get<InfoCobrancaChamado>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/descritivo-cobranca`, { params: params });
  }

  toggleExecutarTarefa(tarefa: Tarefa) {
    return this.http.put<any>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/tarefa/${tarefa.id}`, tarefa);
  }

  atribuirChamado(chamado: Chamado) {
    return this.http.put<Chamado>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${chamado.id}/atribuir`, chamado);
  }

  finalizarChamado(chamado: Chamado) {
    return this.http.put<any>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${chamado.id}/finalizar`, chamado);
  }

  emDeslocamento(chamado: Chamado) {
    return this.http.put<Chamado>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${chamado.id}/em-deslocamento`, chamado);
  }

  chegada(chamado: Chamado) {
    return this.http.put<Chamado>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${chamado.id}/chegada`, chamado);
  }

  avaliarChamado(chamado: Chamado) {
    return this.http.put<Chamado>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${chamado.id}/avaliacao`, chamado);
  }

  addPendencia(pendencia: Pendencia) {
    return this.http.post<Pendencia>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/add-pendencia`, pendencia);
  }

  getPendenciasAbertas(id: number) {
    return this.http.get<Pendencia[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${id}/pendencias`);
  }

  getTiposAtendimento() {
    return this.http.get<TipoAtendimento[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/tipos-atendimento`);
  }

  updateTipoAtendimento(id: number, tipoAtendimentoId: number) {
    return this.http.put<Chamado>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/tipos-atendimento/${id}`, { tipo_atendimento_id: tipoAtendimentoId });
  }

  salvarValores(id: number, valores: ValoresChamado) {
    return this.http.post(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${id}/valores`, valores);
  }

  getPmoc(id: number) {
    return this.http.get<string[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${id}/pmoc`);
  }

  reabrirChamado(id: number) {
    return this.http.put<Chamado>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/${id}/reabrir`, null);
  }
}
